/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_Notify_UrlInputs */

const en_admin_settings_fields_alipay_notify_url = /** @type {(inputs: Admin_Settings_Fields_Alipay_Notify_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notify URL (Webhook)`)
};

/**
* | output |
* | --- |
* | "Notify URL (Webhook)" |
*
* @param {Admin_Settings_Fields_Alipay_Notify_UrlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_notify_url = /** @type {((inputs?: Admin_Settings_Fields_Alipay_Notify_UrlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_Notify_UrlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_alipay_notify_url(inputs)
});
export { admin_settings_fields_alipay_notify_url as "admin.settings.fields.alipay_notify_url" }